import { render, staticRenderFns } from "./otaManage.vue?vue&type=template&id=cc9d013a&scoped=true"
import script from "./otaManage.vue?vue&type=script&lang=js"
export * from "./otaManage.vue?vue&type=script&lang=js"
import style0 from "./otaManage.vue?vue&type=style&index=0&id=cc9d013a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9d013a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc9d013a')) {
      api.createRecord('cc9d013a', component.options)
    } else {
      api.reload('cc9d013a', component.options)
    }
    module.hot.accept("./otaManage.vue?vue&type=template&id=cc9d013a&scoped=true", function () {
      api.rerender('cc9d013a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/ota/otaManage.vue"
export default component.exports